import { configureStore } from '@reduxjs/toolkit'
import {default as messageLoader} from './message';
import loginReducer  from './signInUpSlice'
import artistReducer  from './artistSlice'
import keywordReducer from './keywordSlice'
import artistImageReducer from './artistImageSlice'
import artistDataAPI from './artistDataSlice';
import AgentDataAPI from "./agentSlice";
import artistImageDataSlice from './artistImageDataSlice';
import artistImageKeywordDataSlice from './artistImageKeywordDataSlice';
import artistImageDivisionDataSlice from './artistImageDivisionDataSlice';
import selectedDivision from './selectedDivision';
import AddToCart from './addToCart';
import bannerImages from './bannerImages';




export const store = configureStore({
  reducer: {
    'message':messageLoader,
    loginReducer,
    artistReducer,
    keywordReducer,
    AgentDataAPI,
    artistImageReducer,
    artistDataAPI,
    artistImageDataSlice,
    artistImageKeywordDataSlice,
    artistImageDivisionDataSlice,
    selectedDivision,
    AddToCart,
    bannerImages
  },
  middleware: (getDefaultMiddleware) => getDefaultMiddleware({
    serializableCheck: false
  }),
})
